import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class TappleProductAssurance extends Component {
  #section;
  #request = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#update);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#request++;
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#update);
  }

  #update = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const request = ++this.#request;
    this.querySelector('.tl-stock-badge')?.remove();
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || request !== this.#request || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const updated = [...detail.html.querySelectorAll('tapple-product-assurance')]
        .find((element) => element.dataset.blockId === this.dataset.blockId);
      if (!updated) return;
      this.dataset.productId = updated.dataset.productId;
      morph(this, updated, { childrenOnly: true });
    } catch {
      if (request === this.#request) this.querySelector('.tl-stock-badge')?.remove();
    }
  };
}

if (!customElements.get('tapple-product-assurance')) {
  customElements.define('tapple-product-assurance', TappleProductAssurance);
}
